import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, salesforceLeadId, onClose, onCreateAnother }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-lg border border-border elevation-3 max-w-md w-full p-8 animate-slide-in">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center mb-4">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" />
          </div>
          
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            Lead Submitted Successfully!
          </h2>
          
          <p className="text-muted-foreground mb-6">
            Your lead has been created and synchronized with Salesforce.
          </p>

          <div className="w-full bg-muted/30 rounded-lg p-4 mb-6">
            <p className="text-sm text-muted-foreground mb-1">Salesforce Lead ID</p>
            <p className="text-lg font-semibold text-foreground font-data">{salesforceLeadId}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <Button
              variant="outline"
              onClick={onClose}
              fullWidth
              iconName="LayoutDashboard"
              iconPosition="left"
            >
              Go to Dashboard
            </Button>
            <Button
              variant="default"
              onClick={onCreateAnother}
              fullWidth
              iconName="Plus"
              iconPosition="left"
            >
              Create Another Lead
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;